export default "__VITE_ASSET__DlmuLVjF__"